"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

import { LinkButton } from "@/components/links/LinkButton";
import { createStripePortalAction } from "@/data/payment/actions/createStripePortalAction";
import { logError } from "@/utils/logError";

export function PaymentHistoryLink({ className }: { className?: string }) {
  const router = useRouter();

  const [isLoading, setIsLoading] = useState(false);

  const showPaymentHistory = async () => {
    setIsLoading(true);

    try {
      const stripePortalUrl = await createStripePortalAction({
        typeOfPortal: "invoiceHistory",
        stripeIdPriceForSubscriptionUpdateConfirm: null,
      });

      if (stripePortalUrl !== null) {
        router.push(stripePortalUrl);
      }
    } catch (error) {
      console.error("Error showing payment history", error);
      logError("Error showing payment history");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LinkButton
      className={twMerge(className, "flex items-center")}
      onClick={showPaymentHistory}
      loading={isLoading}
    >
      Payment history & billing info →
    </LinkButton>
  );
}
